enum RoundStatus {
    notStarted,
    paired,
    completed
}

export default RoundStatus;